module.exports = __webpack_public_path__ + "static/media/24_l_ugol_0_0.70c0a9a1.png";